export default __webpack_public_path__ + "static/media/diamond.f1952509.webp";